package site.shadadman.pages.worklog.marketmlm

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initJul222017MarketmlmOfflineFirstPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("worklog/marketmlm/jul222017MarketmlmOfflineFirst.md", FrontMatterElement.Builder { addScalar("title", "22jul2017MarketmlmOfflineFirst"); }))
}

@Page("/worklog/marketmlm/jul222017-marketmlm-offline-first")
@Layout(".components.layouts.MarkdownLayout")
@Composable
fun Jul222017MarketmlmOfflineFirstPage() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("jul-22-2017-MarketMLM_Offline_First This week at MarketMLM:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("We faced a new decision on what to use for local database and what section should be offline-first:")
            org.jetbrains.compose.web.dom.Ul {
                org.jetbrains.compose.web.dom.Li {
                    org.jetbrains.compose.web.dom.Text("For this we asked ourself a couple of questions:")
                    org.jetbrains.compose.web.dom.Ol {
                        org.jetbrains.compose.web.dom.Li {
                            org.jetbrains.compose.web.dom.Text("whats the domain of platform?  its e-commerce that uses wordpress.")
                        }
                        org.jetbrains.compose.web.dom.Li {
                            org.jetbrains.compose.web.dom.Text("Since its product based, Do we need to make the home page offline and store products? it would be good for ux but we decided not do that. one reason was price of the product was changing by minutes.")
                        }
                        org.jetbrains.compose.web.dom.Li {
                            org.jetbrains.compose.web.dom.Text("Do we need to make the profile offline available? that was yes ofcourse, but what part? we had a multi-role profile including customers,vendors and marketers. each role has different features, but the customer role was the base one, all others had customer profile feature inherited, so for now we decided to make the customer role offline-first.")
                        }
                        org.jetbrains.compose.web.dom.Li {
                            org.jetbrains.compose.web.dom.Text("What other section would be good for ux to be offline-first? we decided that the cart section would be great for that. user can see its cart and the products waited for purchase, this can be a good reminder for user. Another section was the ticket section. Customer support is always a important section. User may need info from that section or destails of an answered ticket. now another question will arise. should we3 store the important category or just store the last 20 ticket. will we cameup with a better solution, we give the user the ability to select what ticket it needs to be accessed offline. this was a good decision.")
                        }
                    }
                }
            }
        }
    }
}
